
import * as cloudflareRuntime$LuonaU0GpKJ_or5qOxXdORktona5q9Vzx4HGa7XsAYM from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$LuonaU0GpKJ_or5qOxXdORktona5q9Vzx4HGa7XsAYM, defaults: {"baseURL":"https://app.pipeback.com"} }
}
        